import React from 'react';

export default class PromoCodeInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			open: this.props.open ? this.props.open : false,
			promo_code: '',
			rate: {id: null},
			rates: [],
		}

		this.onChangePromoCode = this.onChangePromoCode.bind(this);
		this.onClear = this.onClear.bind(this);
		this.onClickRate = this.onClickRate.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onToggleDropdown = this.onToggleDropdown.bind(this)
	};

	componentDidMount() {
		var self = this;

		// load rates
		this.loadRates();

		// setup window click handler to hide dropdown
		$(window).on('click.PromoCodeInput', function (e) {
      var $target = $(e.target);
			if (self && self.state && self.state.open && $target.parents('.special-rates-dropdown').length === 0) {
				self.setState({open: false});
			}
		});
	};

	componentDidUpdate(prevProps) {
		if (this.props.promo_rates_list_path && !prevProps.promo_rates_list_path ) {
			this.loadRates();
		};
	};

	componentWillUnmount() {
		$(window).off('click.PromoCodeInput');
	};

	render() {
		var rateButtons = this.state.rates.map( (rate) => {
			return (
				<div className="rate-button-wrapper" key={rate.id}>
					<button type="button" className={"btn-secondary " + (this.state.rate && this.state.rate.id === rate.id ? 'active' : '')} onClick={this.onClickRate.bind(null, rate)} >
						{rate.name}
						<span className="check" style={{visibility: (this.state.rate && this.state.rate.id === rate.id ? 'visible' : 'hidden')}}>✓</span>
					</button>
				</div>
			);
		});

		var rate_name = this.props.labeled === false ? I18n.t('none') : I18n.t('special_rates')
		if (!this.state.rate && this.state.promo_code !== '') {
			rate_name = this.state.promo_code
		} else if (this.state.rate && this.state.rate.id) {
			rate_name = this.state.rate.name
		};

    if(rate_name.length > 19){
      rate_name = rate_name.substr(0, 19 - 3) + '...'
    }

		return (
			<div className="dropdown special-rates-dropdown">
			  <button className="btn-secondary dropdown-toggle" type="button" onClick={this.onToggleDropdown}>
			    <span className="option" style={{paddingBottom: '5px'}}>{rate_name}</span>
			    <span className="caret"></span>
			  </button>
			  <div className="dropdown-menu" style={{display: this.state.open ? 'block' : 'none'}}>
			  	{rateButtons}
			  	<form onSubmit={this.onSubmit}>
						<div className="form-group" style={{marginBottom: 0}}>
							<label>{I18n.t('promo_code')}</label>
							<input type="text" className="form-control" value={this.state.promo_code} name="promo_code" onChange={this.onChangePromoCode} />
						</div>
					</form>
			  </div>
			</div>
		);
	};

	/**
	* Change handlers
	*/

	onChangePromoCode(e) {
		var self = this;
		e.persist();
		this.setState({promo_code: e.target.value}, function () {
			self.props.onChange(e);
		});
	}

	onClear() {
		this.props.onChange({
			target: {
				name: this.props.name,
				value: ''
			}
		}, this.props.onSubmit)
	}

	onClickRate(rate, e) {
		var self = this;
		e.stopPropagation();
		e.preventDefault();

		return new Promise ((resolve, reject) => {
			this.setState({rate: rate, promo_code: '', open:false}, function () {
        self.props.onChange({ target: { name: 'promo_code', value: rate.code } }, self.onSubmit)
			});
		});

	};

	onSubmit(e) {
		// e.stopPropagation();
		// e.preventDefault();

		this.props.onSubmit(e);

		this.setState({open: false});

		if (this.state.promo_code !== '') {
			this.setState({rate: null});
		}

	}

	onToggleDropdown(e) {
		if (e && e.stopPropagation && e.preventDefault) {
			e.stopPropagation();
			e.preventDefault();
		}

		this.setState({open: !this.state.open}, () => {
      this.closeGuestSelect();
    });
	};

	/**
	* Helpers
	*/

  closeGuestSelect = () => {
    $(window).trigger('click.guest_types_dropdown')
  };

	loadRates() {
		var self = this;
	    $.ajax({
	      type: 'POST',
	      url: this.props.promo_rates_list_path,
        data: {
          api_key: this.props.account && this.props.account.api_key ? this.props.account.api_key : null,
          property: this.props.property && this.props.property.id ? this.props.property.id : null,
          property_id: this.props.property && this.props.property.id ? this.props.property.id : null,
          website_rates: this.props.property ? true : false,
        },
	    }).done((data) => {
	      if (data && data.rates) {
	      	data.rates.unshift({id: null, name: I18n.t('none')});
	      	self.setState({rates: data.rates});
	      }
	    });
	}

}
